module.exports = __webpack_public_path__ + "static/balogun-0ab99fe53302c08c8a4bf8f8e591ef4c.png";